/**
 * Error that is thrown when more than the allowed number of files are selected to be uploaded
 */
export class MaxUploadsExceededError extends Error {
    constructor(message, files) {
        super(message);
        Object.defineProperty(this, "files", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'MaxUploadsExceededError';
        this.files = files;
    }
}
//# sourceMappingURL=MaxUploadsExceededError.js.map